import styled from 'styled-components';
import React, {FC} from 'react';

import {StyledLeftMenuButton} from '../headerMenu';
import {HeaderMenuProps} from '../headerMenuTypes';
import {HeaderSubMenu} from '../headerSubMenu';
import {transition} from '../../../../../lib/styleVariables';
import {paletteR4} from '../../../../../lib/styleVariablesR4';
import {hasHref} from '../headerUtils';
import {headerHeight} from '../headerVariables';

interface HeaderLeftNavProps {
  leftNav: HeaderMenuProps['leftNav'];
  isHeaderHighlighted?: boolean;
  isScrolled: boolean;
  locationPath: string;
}

export const StyledLeftMenuButtonText = styled.span`
  display: flex;
  align-items: center;
  position: relative;

  &::before,
  &::after {
    width: 100%;
    content: '';
    position: absolute;
    left: 0;
    top: 100%;
    visibility: hidden;
    opacity: 0;
    transition: ${transition.fast};
  }

  &::before {
    height: ${(headerHeight.desktop - 25) / 2 -
      2}px; /* 25px is menu items height and 2px is height of the hover line */
  }

  &::after {
    height: 2px;
    background: ${paletteR4.black.base};
    transform: translateY(${(headerHeight.desktop - 25) / 2 - 2}px);
  }
`;

export const HeaderLeftNav: FC<HeaderLeftNavProps> = props => (
  <>
    {props.leftNav.map(item => {
      if (hasHref(item))
        return (
          <StyledLeftMenuButton href={item.href} isActive={item.href === props.locationPath} key={item.name}>
            <StyledLeftMenuButtonText>{item.name}</StyledLeftMenuButtonText>
          </StyledLeftMenuButton>
        );

      const hasActiveSubLink = item.subMenu.items.some(subItem =>
        subItem.items.some(subLink => subLink.href === props.locationPath)
      );

      return (
        <StyledLeftMenuButton as="span" isActive={hasActiveSubLink} key={item.name}>
          <StyledLeftMenuButtonText>{item.name}</StyledLeftMenuButtonText>
          <HeaderSubMenu {...item} locationPath={props.locationPath} />
        </StyledLeftMenuButton>
      );
    })}
  </>
);
